import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'sal_center': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'gjahr': {
    title: '年度',
    type: 'input',
    equation: cusname
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'initplan_dun': {
    title: '初始数量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'initplan_qty': {
    title: '初始数量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'change_dun': {
    title: '变动量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'change_qty': {
    title: '变动量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'change': {
    title: '变动日期',
    type: 'date',
    equation: cusname
  },
  'remain_dun': {
    title: '剩余总量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'remain_qty': {
    title: '剩余总量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/centerSumChangeReportForms.js